(function() {
  'use strict';

  function setupDragScroll(grid) {
    // Check if mobile/tablet
    if (window.innerWidth > 989) return;
    
    // Skip if already has drag listeners
    if (grid.dataset.dragEnabled === 'true') return;
    
    // Ensure grid can scroll
    const computedStyle = window.getComputedStyle(grid);
    if (computedStyle.overflowX === 'visible') {
      grid.style.overflowX = 'auto';
    }
    
    grid.dataset.dragEnabled = 'true';
    
    let isDown = false;
    let startX = 0;
    let scrollLeft = 0;
    let hasMoved = false;

    // Mouse events
    grid.addEventListener('mousedown', (e) => {
      if (e.target.closest('a')) return;
      
      e.preventDefault();
      isDown = true;
      hasMoved = false;
      grid.style.cursor = 'grabbing';
      grid.style.userSelect = 'none';
      startX = e.pageX - grid.offsetLeft;
      scrollLeft = grid.scrollLeft;
    });

    grid.addEventListener('mouseleave', (e) => {
      if (isDown) {
        isDown = false;
        grid.style.cursor = 'grab';
        grid.style.userSelect = '';
        // Stop any scrolling immediately
        e.preventDefault();
      }
    });

    grid.addEventListener('mouseup', (e) => {
      if (isDown) {
        isDown = false;
        grid.style.cursor = 'grab';
        grid.style.userSelect = '';
        // Stop any scrolling immediately
        e.preventDefault();
      }
    });

    grid.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      e.stopPropagation();
      hasMoved = true;
      const x = e.pageX - grid.offsetLeft;
      const walk = (x - startX) * 1.5;
      grid.scrollLeft = scrollLeft - walk;
    });

    // Touch events
    let touchStartX = 0;
    let touchScrollLeft = 0;

    grid.addEventListener('touchstart', (e) => {
      if (e.target.closest('a')) return;
      
      isDown = true;
      hasMoved = false;
      touchStartX = e.touches[0].pageX;
      touchScrollLeft = grid.scrollLeft;
    }, { passive: false });

    grid.addEventListener('touchend', (e) => {
      if (isDown) {
        isDown = false;
        // Stop any scrolling immediately
        e.preventDefault();
      }
    }, { passive: false });

    grid.addEventListener('touchmove', (e) => {
      if (!isDown) {
        // If not dragging, allow normal scroll
        return;
      }
      
      const touchX = e.touches[0].pageX;
      const walk = touchX - touchStartX;
      
      // Only scroll if we're actively dragging
      if (Math.abs(walk) > 3) {
        e.preventDefault();
        e.stopPropagation();
        hasMoved = true;
        grid.scrollLeft = touchScrollLeft - walk;
      }
    }, { passive: false });

    // Prevent native wheel scroll while dragging
    grid.addEventListener('wheel', (e) => {
      if (isDown) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, { passive: false });
    
    // Prevent link clicks if dragged
    grid.addEventListener('click', (e) => {
      if (hasMoved && e.target.closest('a')) {
        e.preventDefault();
        e.stopPropagation();
      }
      hasMoved = false;
    }, true);
  }

  function initDragScroll() {
    const grids = document.querySelectorAll('.feature-cards__grid');
    if (grids.length === 0) return;
    
    grids.forEach(grid => {
      // Only setup if on mobile/tablet
      if (window.innerWidth <= 989) {
        setupDragScroll(grid);
      }
    });
  }

  // Initialize when DOM is ready
  function initialize() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initDragScroll);
    } else {
      initDragScroll();
    }
    
    // Also try after delays for dynamically loaded content
    setTimeout(initDragScroll, 500);
    setTimeout(initDragScroll, 1000);
  }

  initialize();
})();
